// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=Agent|schemaHash=754142f86f21cee88f1a9410f7268f5d732dda14

import { setDefinedValue } from '@myre/common-primitives';

import { parseMcpServerInfoFromJSON, parseMcpServerInfoToJSON } from './McpServerInfo';

export function parseAgentFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'mcpServers',
    Array.isArray(_data.mcpServers)
      ? _data.mcpServers.map(item =>
          parseMcpServerInfoFromJSON(item),
        )
      : _data.mcpServers,
  );
  setDefinedValue(result, 'name', _data.name);
  setDefinedValue(result, 'icon', _data.icon);
  setDefinedValue(result, 'inputPlaceholder', _data.inputPlaceholder);
  setDefinedValue(result, 'acceptUpload', _data.acceptUpload);
  setDefinedValue(result, 'acceptUploadFileTypes', _data.acceptUploadFileTypes);
  setDefinedValue(result, 'isDefault', _data.isDefault);
  setDefinedValue(result, 'suggestions', _data.suggestions);

  return result;
}

export function parseAgentToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'mcpServers',
    Array.isArray(_data.mcpServers)
      ? _data.mcpServers.map(item =>
          parseMcpServerInfoToJSON(item),
        )
      : _data.mcpServers,
  );
  setDefinedValue(result, 'name', _data.name);
  setDefinedValue(result, 'icon', _data.icon);
  setDefinedValue(result, 'inputPlaceholder', _data.inputPlaceholder);
  setDefinedValue(result, 'acceptUpload', _data.acceptUpload);
  setDefinedValue(result, 'acceptUploadFileTypes', _data.acceptUploadFileTypes);
  setDefinedValue(result, 'isDefault', _data.isDefault);
  setDefinedValue(result, 'suggestions', _data.suggestions);

  return result;
}
